/** Fixed ambient light field that glass surfaces refract. Purely decorative. */
export function Backdrop() {
  return <div className="backdrop-field" aria-hidden="true" />;
}
